import React from 'react';
import { useSelector } from 'react-redux';

import { InfoOutlined } from '@material-ui/icons';
import { Box, Typography } from '@material-ui/core';
import { SECONDARY_COLOR } from '../../../../constants/enums';

import KPTextform from '../../../../components/KPTComponents/KPTextform';

import { useScreenSize } from '../../../../hooks/useScreenSize';
import { REWARD_CONSTANTS } from '../../../../constants';
import { getQcvScoreOptions } from '../../../../utils/qcvScoreOptions';

export const rewardForm = (values, mobileMode, disabled, typeOptions) => ([
  {
    key: 'title',
    width: 12,
    height: 1,
    label: 'Tên giải thưởng',
    value: values?.title,
    disabled,
    required: true,
    note: (
      <Box display="flex" alignItems="center" style={{ color: SECONDARY_COLOR }}>
        <InfoOutlined style={{ width: 16 }} />
        &nbsp;<b>Lưu ý:</b>&nbsp;
        Không gồm những thành tích đã khai ở các tiêu chuẩn trên
      </Box>
    )
  },
  { key: 'author', width: 12, height: 1, label: 'Danh sách đoạt giải', value: values?.author, disabled, required: true },
  { key: 'type', width: 12, label: 'Loại giải thưởng', value: values?.type, options: typeOptions || REWARD_CONSTANTS.typeOptions, disabled, required: true },
  { key: 'code', width: 6, label: mobileMode ? 'Số quyết định':'Số quyết định khen thưởng', value: values?.code, disabled, required: true},
  { key: 'decisionDay', width: 6 , label:mobileMode ? 'Ngày quyết định':'Ngày quyết định khen thưởng',type: 'date',value: values?.decisionDay, disabled, required: true },
  { key: 'unit', width: 12, height: 1, label: 'Cơ quan, tổ chức ra quyết định khen thưởng', value: values?.unit, disabled, required: true },
  {
    key: 'previewFile',
    width: 12,
    value: values?.previewFile,
    type: 'file',
    acceptedFiles: ["image/*", "application/pdf"],
    label: (
      <>
        <Typography variant='body1' style={{ fontSize: 17 }}>
          <b>Upload file minh chứng tại đây</b>
        </Typography>
        <Typography variant='body2' color='secondary'>
          (Hình ảnh/ file PDF bằng khen/ giấy khen)
        </Typography>
      </>
    ),
    disabled, required: true
  },
]);

export default function GiaiThuongForm(props) {
  const isMobileMode = useScreenSize();

  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  // Mục 7 (bảng điểm QCV): "Loại giải thưởng" lấy động từ qcv_score_infos
  // (code 7.x) thay cho REWARD_CONSTANTS.typeOptions hardcode.
  const muc7Options = getQcvScoreOptions(scoreInformationList, '7');
  const typeOptions = muc7Options.length ? muc7Options : REWARD_CONSTANTS.typeOptions;

  const textForm = rewardForm(props.values, isMobileMode, props.disabled, typeOptions)

  return (
    <KPTextform {...props} textForm={textForm} />
  );
}